module.exports = {
  getWebSocketBase: function () {
    if (process.env.REACT_APP_DEEPSTREAM_HOST !== undefined) return process.env.REACT_APP_DEEPSTREAM_HOST
    var base = (window.location.protocol === 'http:' ? 'ws://' : 'wss://')
    var host = (window.location.hostname === 'localhost' ? 'vigrid.int.maintrac.se/deepstream' : window.location.host)
    return base + host
  },
  getHTTPBase: function () {
    var base = (window.location.protocol === 'http:' ? 'http://' : 'https://')
    var host = (window.location.hostname === 'localhost' ? 'vigrid.int.maintrac.se/' : window.location.host + '/')
    return base + host
  }
}



// WEBPACK FOOTER //
// ./src/helpers/host.js